import React, { useContext, useEffect, useState } from 'react';
import S from "./RegionDestribution.styled";
import FundContext from "@/components/FundSingle/FundProvider";
import Map from "./map";
import CountryMapping from "@/components/FundSingle/portfolio-analysis-helper/mappings/country-mapping.json";
import moment from 'moment';
import regions from "./regions";
import swedishCountryMappings from "./swedishCountryMappings";

const RegionDestribution: React.FC = () => {
    // Get the data from the context
    const { portfolio } = useContext(FundContext);
    const [ mapData, setMapData ] = useState([]);
    const currentFormattedDate = moment(portfolio.Date).format('YYYY-MM-DD');

    function getSwedishCountryName(country: string) {
        if (swedishCountryMappings[country]) {
            return swedishCountryMappings[country];
        }

        return country;
    };

    useEffect(() => {
        if (!portfolio || Object.keys(portfolio).length === 0) return;

        var countryBreakdowns = portfolio.CountryExposure[0].BreakdownValues;
        
        countryBreakdowns.sort((a, b) => {
            return b.Value - a.Value;
        });

        // Loop through the country breakdowns
        for (var i = 0; i < countryBreakdowns.length; i++) {
            var country = countryBreakdowns[i].Type;
            var value = countryBreakdowns[i].Value;

            // Check if the country is in the mapping (lowercase)
            if (CountryMapping[country.toLowerCase()]) {
                countryBreakdowns[i].Country = CountryMapping[country.toLowerCase()];
            }
        }
        
        var regionBreakdowns = [];

        // Loop through the country breakdowns, find them in regions, and add them to the region breakdowns
        for (var i = 0; i < countryBreakdowns.length; i++) {
            var country = countryBreakdowns[i].Country;
            var value = countryBreakdowns[i].Value;

            Object.keys(regions).forEach((region) => {
                if (regions[region].includes(country)) {
                    if (regionBreakdowns[region] == undefined) {
                        regionBreakdowns[region] = {
                            value: 0,
                            countries: []
                        };
                    }
                    
                    regionBreakdowns[region].value += value;
                    regionBreakdowns[region].countries.push({
                        name: getSwedishCountryName(country),
                        value: value
                    });
                }
            });
        }

        setMapData(regionBreakdowns);
         

    }, [portfolio]);
    
    if (mapData == undefined) return null;

    // Exampledata
    var data = {
        'headers': ['LAND', 'ANDEL'],
        // 'rows': mapData.map((country) => {
        //     return [country.Type, Math.round(country.Value * 100) / 100, country.Country];
        // })
        'rows': mapData
    }

    return (
        <S.RegionDestributionWrapper>
            <S.RegionDestributionMapWrapper>
                <Map data={data} />
            </S.RegionDestributionMapWrapper>
            <S.RegionDistributionTableWrapper>
                
                <S.RegionDistrubtionTableHeader>
                    <S.RegionDistrubtionTableHeaderCell>
                        <S.RegionDistributionTableHeaderHeading>Regionsfördelning %</S.RegionDistributionTableHeaderHeading>
                    </S.RegionDistrubtionTableHeaderCell>
                    <S.RegionDistrubtionTableHeaderCell>
                        <S.RegionDistributionTableHeaderDate>{currentFormattedDate}</S.RegionDistributionTableHeaderDate>
                    </S.RegionDistrubtionTableHeaderCell>
                </S.RegionDistrubtionTableHeader>

                <S.RegionDistributionTable>
                    <thead>
                        <tr>
                            {data.headers.map((header, index) => {
                                return <th key={index}>{header}</th>
                            })}
                        </tr>
                    </thead>
                    <tbody>
                        {Object.keys(data.rows).map((row, index) => {
                            return (
                                <>
                                <tr key={index}>
                                    <td><b>{row}</b></td>
                                    <td>{Math.round(data.rows[row].value * 100) / 100}%</td>
                                </tr>
                                {data.rows[row].countries.map((subRegion, index) => {
                                    return (
                                        <tr key={index}>
                                            <td>{subRegion.name}</td>
                                            <td>{Math.round(subRegion.value * 100) / 100}%</td>
                                        </tr>
                                    );
                                })}
                                </>
                            );
                        })}
                    </tbody>
                </S.RegionDistributionTable>

            </S.RegionDistributionTableWrapper>
        </S.RegionDestributionWrapper>
    );
};

export default RegionDestribution;
